export default __webpack_public_path__ + "static/media/white_mic.466b680d.svg";